import { HttpClient, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, throwError as observableThrowError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "src/environments/environment"; // Importar environment

@Injectable({
    providedIn: "root",
})
export class AuthHttpInterceptorService implements HttpInterceptor {
    constructor(private route: Router) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Evitar interceptar peticiones de Microsoft Auth o que tengan skipInterceptor
        if (req.headers.has("skipInterceptor") || req.url.includes("/api/auth/me")) {
            return next.handle(req);
        }

        const jwt = this.getToken();

        // Aplicar el token solo si la URL coincide con environment.apiBaseUrl
        if (jwt && req.url.startsWith(environment.apiBaseUrl)) {
            req = req.clone({
                setHeaders: { Authorization: "Bearer " + jwt },
            });
        }

        return next.handle(req).pipe(
            catchError((err) => {
                if (err.status === 401 || err.statusText === "Unknown Error") {
                    this.route.navigateByUrl("/sesion-expirada");
                    console.error(err);
                }
                return observableThrowError(err);
            })
        );
    }

    getToken() {
        return JSON.parse(sessionStorage.getItem("Token"));
    }
}
